export function getApiBase() {
  const cfg =
    typeof window !== "undefined"
      ? window.__BUUKKERI_CONFIG__ || {}
      : {};

  const appConfig =
    typeof window !== "undefined"
      ? window.APP_CONFIG || {}
      : {};

  // Local dev käyttää edelleen local-API:a / .env-asetusta.
  const host =
    typeof window !== "undefined" && window.location?.hostname
      ? window.location.hostname
      : "";

  const isLocalHost = host === "localhost" || host === "127.0.0.1";

  const useLocal =
    String(process.env.REACT_APP_USE_LOCAL_API || "").toLowerCase() === "true";

  if (isLocalHost || useLocal) {
    return (
      process.env.REACT_APP_API_BASE ||
      `${window.location.protocol}//${window.location.hostname}:8080`
    );
  }

  // WordPress antaa stagingissa/tuotannossa osoitteen APP_CONFIG.API_URL:ssa.
  // API_URL sisältää jo lopun "/api", mutta services/api.js lisää sen itse,
  // joten poistetaan "/api" tästä ennen palautusta.
  const runtimeBase =
    cfg.API_BASE ||
    appConfig.API_URL ||
    process.env.REACT_APP_API_BASE ||
    "";

  return String(runtimeBase)
    .trim()
    .replace(/\/api\/?$/i, "")
    .replace(/\/+$/, "");
}